module.exports = __webpack_public_path__ + "img/medium-icon.7f7b9486.svg";